import partition from 'lodash/partition';

import type { HasMenuId, NavItemConfigInternal } from '../../types';

export const partitionByReorderable = <T extends HasMenuId & NavItemConfigInternal>(
	items: T[],
): [T[], T[]] => partition(items, (item) => item.isReorderable);
